export default function Input({className, password, hidden, number, url, email, multiLine, ...props})
{
  const Tag = multiLine ? 'textarea' : 'input';
  return <Tag
    className={`p-1 px-2 bg-gray-300 dark:bg-gray-700 ${(props.readOnly || props.disabled) && 'bg-opacity-50 dark:bg-opacity-50'} rounded w-full outline-none ${className}`}
    type={password ? 'password' : hidden ? 'hidden' : number ? 'number' : url ? 'url' : email ? 'email' : 'text'}
    {...props} />;
}
